import React from 'react';
import { TVirtualWindowData } from '../../types';
import '../../scss/windows-tab-bar.scss';

interface MinimizedWindowsBarProps {
  windows: TVirtualWindowData[];
  minimizedWindows: TVirtualWindowData[];
  onFocus: (windowId: string) => void;
  onRestore: (windowId: string) => void;
  onClose: (windowId: string) => void;
}

const MinimizedWindowsBar: React.FC<MinimizedWindowsBarProps> = ({
  windows,
  minimizedWindows,
  onFocus,
  onRestore,
  onClose,
}) => {
  const allWindows = [...windows, ...minimizedWindows];
  if (allWindows.length === 0) return null;

  const isMinimized = (id: string) => minimizedWindows.some((w) => w.id === id);

  return (
    <div className="windows-tab-bar">
      {allWindows.map((w) => (
        <div
          key={w.id}
          className={`window-tab ${w.focused ? 'active' : ''}`}
          onClick={() => isMinimized(w.id) ? onRestore(w.id) : onFocus(w.id)}
        >
          <i className="file-icon">📄</i>
          <span className="window-tab-title">{w.title}</span>
          <button
            className="window-tab-close"
            onClick={(e) => { e.stopPropagation(); onClose(w.id); }}
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  );
};

export default MinimizedWindowsBar;
